import Footer from "../components/Footer";
import Helmet from "react-helmet";
import PropTypes from "prop-types";
import React from "react";
import ReactGA from "react-ga";
import TopBar from "../components/TopBar";
import injectSheet from "react-jss";
import { withPrefix } from "gatsby-link";

// Need media queries at: 375, 414, 768, 1024 pixel widths
const styles = {
  root: {
    fontFamily: "Helvetica Neue, Open Sans, Arial, sans-serif",
    width: "100%",
    margin: 0,
    padding: 0
  },
  page: {
    width: "100%",
    margin: 0,
    padding: 0
  }
};

const redirectTo = url => {
  if (typeof window !== "undefined") {
    if (window.location.pathname.startsWith(url)) {
      return;
    }
    window.location.href =
      window.location.protocol + "//www.electedtechnologies.com" + url;
  }
};

class Layout extends React.Component {
  static propTypes = {
    children: PropTypes.func,
    classes: PropTypes.object,
    location: PropTypes.object
  };

  componentDidMount() {
    // Route legacy URLs to sub-directories of main site
    if (typeof window !== "undefined") {
      switch (window.location.hostname) {
        case "www.caseworkermp.com":
        case "www.caseworker.mp":
          redirectTo("/mp");
          break;
        case "www.caseworkermla.com":
          redirectTo("/mla");
          break;
        case "www.caseworkergov.com":
          redirectTo("/gov");
          break;
        case "www.caseworker.scot":
          redirectTo("/scot");
          break;
        case "www.voter.id":
          redirectTo("/voter");
          break;
        case "www.caseworker.com.au":
        case "www.caseworker.net.au":
          redirectTo("/mpau");
          break;
      }
      var request = new XMLHttpRequest();
      request.open(
        "GET",
        "https://api.ipdata.co/?api-key=fd9e39ee416981d271abf5d6b0711872c21f157144437ea5f1812129"
      );
      request.setRequestHeader("Accept", "application/json");
      request.onreadystatechange = function() {
        if (this.readyState === 4) {
          if (
            window.location.hostname === "www.caseworkermp.com" ||
            window.location.hostname === "www.caseworker.mp" ||
            window.location.pathname.startsWith("/mp")
          ) {
            var response = JSON.parse(this.responseText);
            switch (response.country_code) {
              case "AU":
                redirectTo("/mpau");
                break;
              case "NZ":
                redirectTo("/mpnz");
                break;
            }
          }
        }
      };
      request.send();
      require("smooth-scroll")('a[href*="#"]');
    }
    ReactGA.initialize("UA-69403156-2");
  }

  render() {
    const { children, classes } = this.props;
    return (
      <div className={classes.root}>
        <Helmet
          title="Elected Technologies - Digital Solutions for those in and seeking elected office"
          meta={[
            {
              name: "description",
              content:
                "Elected Technologies, Election Data Platforms, Voter Identification, Casework Management, Casework and Correspondence Management"
            },
            { name: "author", content: "Elected Technologies" },
            { name: "theme-color", content: "#ffffff" },
            { name: "format-detection", content: "telephone=no" }
          ]}
          link={[
            {
              rel: "apple-touch-icon",
              sizes: "180x180",
              href: withPrefix("/apple-touch-icon.png")
            },
            {
              rel: "icon",
              sizes: "32x32",
              type: "image/png",
              href: withPrefix("/favicon-32x32.png")
            },
            {
              rel: "icon",
              sizes: "16x16",
              type: "image/png",
              href: withPrefix("/favicon-16x16.png")
            },
            {
              rel: "manifest",
              href: withPrefix("/manifest.json")
            },
            {
              rel: "mask-icon",
              color: "#42aad8",
              href: withPrefix("/safari-pinned-tab.svg")
            },
            {
              rel: "stylesheet",
              type: "text/css",
              href: withPrefix("/normalize.css")
            },
            {
              rel: "stylesheet",
              href: "//fonts.googleapis.com/css?family=Open+Sans:300,300i,400"
            }
          ]}
          script={[
            { src: withPrefix("/tracklinks.js"), type: "text/javascript" },
            { src: withPrefix("/googleanalytics.js"), type: "text/javascript" },
            { src: withPrefix("/onclick.js"), type: "text/javascript" }
          ]}
        />
        <div className={classes.page}>
          <TopBar />
          {children()}
          <Footer />
        </div>
      </div>
    );
  }
}

export default injectSheet(styles)(Layout);



// WEBPACK FOOTER //
// ./src/layouts/index.jsx